export default {"src":"/_next/static/media/logo.13d369d3.svg","height":70,"width":77,"blurWidth":0,"blurHeight":0};